import React from 'react';
import PropTypes from 'prop-types';

export const Tag = ({ name, id, ellipsis }) => {
  if (ellipsis)
    return (
      <div className="ellipsis-tag">
        <span>...</span>
      </div>
    );

  return (
    <div className="custom-tag" key={id + name} id={`custom-tag-${id}`}>
      <div className="custom-tag-text">
        <span>#{name}</span>
      </div>
    </div>
  );
};

Tag.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired
};

export default Tag;
